package com.ijoin.i18n

actual fun updatePlatformLocale(languageCode: String) {
    // For web (JS), we can use localStorage to persist the preference
    try {
        js("localStorage.setItem('app_language', languageCode)")
    } catch (e: Exception) {
        console.log("Failed to save language preference: ${e.message}")
    }

    // Note: Actual locale change in browser would require reloading resources
    // or using a different approach with dynamic resource loading
}